/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/31/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('gridSearch', function() {
	return function(array, searchText, searchFields) {
		var result = [];
		var getObject = function (array, item) {
			var result = angular.copy(item);
			for(var i = 0; i < array.length; i++) {
				var prop = array[i];
				if (result.hasOwnProperty(prop)) {
					result = result[prop];
				}
				else {
					return undefined;
				}
			}

			return result;
		};
		if(searchText) {
			var matcher = new RegExp(searchText.toLowerCase());

			array.forEach( function( item ) {
				var field;

				for(var i = 0; i < searchFields.length; i++) {
					field = searchFields[i];
					var compare = getObject(field.split('.'), item);
					if (compare && compare.toLowerCase().match(matcher) ){
						result.push(item);
						break;
					}
				}
			});
			return result;
		}
		return array;
	};

});
